package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.Text

private val search = Bem("admin-search-field")
private val input = Bem("admin-input")

/**
 * A search box for filtering a list as one types, e.g. beside a page header's actions. The [label] is for screen
 * readers only, so [placeholder] says what the search looks at ("Name, E-Mail, Rolle …"). Escape clears it.
 */
@Composable
fun AdminSearchField(
    id: String,
    label: String,
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String? = null,
) {
    Div({ classes(search.block) }) {
        Label(forId = id, attrs = { classes("admin-visually-hidden") }) { Text(label) }
        Input(InputType.Search) {
            classes(input.block, search.element("input").className)
            id(id)
            value(value)
            attr("autocomplete", "off")
            placeholder?.let { placeholder(it) }
            onInput { onValueChange(it.value) }
            onKeyDown { event ->
                if (event.key == "Escape" && value.isNotEmpty()) {
                    event.preventDefault()
                    onValueChange("")
                }
            }
        }
    }
}
